import { ComponentType } from 'react';
import { defaultIcons } from './defaultIcons';

export type WixDesignSystemIconThemeProviderProps = {
  dataHook?: string;
  className?: string;
  as?: 'span' | 'div';
  children?: React.ReactNode;
};

export type IconComponent = ComponentType;

export type IconThemeContextValue = {
  icons: Record<string, Record<string, IconComponent>>;
};

export type IconsTheme = typeof defaultIcons;

export type IconComponentName = keyof IconsTheme;
